export function getTopWindow() {
  let currentWindow = window as Window;

  try {
    while (
      currentWindow !== currentWindow.parent &&
      currentWindow.parent.location.href
    ) {
      // 접근 시도
      currentWindow = currentWindow.parent;
    }
  } catch (e) {
    // 보안 에러가 발생하면 현재 window가 접근 가능한 최상위 window
  }

  return currentWindow;
}
